define('home/views/RecommendationView',[
    'backbone-marionette',

    'home/mixins/withAllstarPopover',
    'home/mixins/withSubviews',

    'home/templates/recommendation',
], function (
    Marionette,

    withAllstarPopover,
    withSubviews,

    recommendationTemplate
) {
    'use strict';

    /**
     * A View that shows an object (like a user or a forum) and a reason that the
     * object is recommended.
     *
     * This View should be backed by a FollowRecommendation.
     *
     * This View should be initialized with the View to use to show the object that
     * is being recommended (ex: RecommendedObjectView: UserSuggestionView).
     */
    var RecommendationView = Marionette.ItemView.extend({
        template: recommendationTemplate,
        className: 'recommended-wrap',

        regions: {
            recommendedObjectRegion: '[data-role=recommended-object]',
        },

        initialize: function (options) {
            this.RecommendedObjectView = options && options.RecommendedObjectView;
        },

        onRender: function () {
            if (this.RecommendedObjectView)
                this.activateRegion(this.recommendedObjectRegion, this.createRecommendedObjectView);
        },

        createRecommendedObjectView: function () {
            return new this.RecommendedObjectView({ model: this.model.object });
        },
    });

    withAllstarPopover.call(RecommendationView.prototype);
    withSubviews.call(RecommendationView.prototype);

    return RecommendationView;
});

